<script setup lang="ts">
import PricingCards from './children/PricingCards.component.vue'
const { translate } = useLocalization()
// retrieve page data passed down from index page
const lcid = <any>useAttrs().lcid
const pricingData = <any>useAttrs().pricingData
const { title, description, footnotes, cards } = pricingData
</script>

<template>
  <div id="pricing" class="bg-card content-card bg-opacity-80 opacity-90 py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto max-w-2xl mb-16 lg:mx-0">
        <h2 class="text-3xl font-bold tracking-tight sm:text-4xl">
          {{ title }}
        </h2>
        <!-- <p v-if="subtitle" class="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">
          {{ subtitle }}
        </p> -->
        <p class="mt-6 text-lg leading-8 opacity-80">
          {{ description }}
        </p>
      </div>

      <div class="mx-auto max-w-2xl md:max-w-2xl lg:max-w-none sm:max-w-none">
        <PricingCards :lcid="lcid" :footnotes="footnotes" :cards="cards" />
      </div>

      <div class="mt-16 mx-auto max-w-2xl lg:max-w-none">
        <a href="#top" class="content-secondary opacity-80 hover:opacity-100 text-sm font-semibold leading-6">
          {{ translate('navigation.top') }} <span aria-hidden="true">→</span>
        </a>
      </div>
    </div>
  </div>
</template>
